import { EVA_API_HOST } from "../config";

export function getPublicEVAImage(src) {
  if (!src) {
    return null;
  }

  return `${EVA_API_HOST}/storage/` + src.slice(7);
}
